<div *ngIf="reportType == 'send-reminder2'">
    <div style="margin-left: 80%; margin-bottom: 2%;">

        <button (click)="printPage()" class="no-print" style="margin-top: 2%; margin-left: 2%" mat-raised-button
            color="primary">
            Print
        </button>
        <button class="no-print" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>

         <!-- ⭐ ADD THIS: bulk send button -->
        <button (click)="sendAllWhatsAppReminders()" class="no-print" style="margin-top: 2%; margin-left: 2%"
            mat-raised-button color="accent" [disabled]="sendingAllWhatsAppReminders || !reportGroups.length">
            {{ sendingAllWhatsAppReminders ? 'पाठवत आहे...' : 'सर्वांना WhatsApp पाठवा' }}
        </button>
    </div>

    <!-- ONE reminder letter PER rep. Each block gets page-break-after in the print CSS
         so every rep prints on its own page. -->
    <div id="print-section">

        <div class="reminder-container rep-letter-block" *ngFor="let group of reportGroups">


            <button mat-raised-button class="no-print" [disabled]="group.isSendingWhatsApp || group.isWhatsAppSent"
                (click)="sendWhatsAppReminderRep(group)">
                {{ group.isWhatsAppSent ? 'पाठवले' : (group.isSendingWhatsApp ? 'पाठवत आहे...' : 'WhatsApp पाठवा') }}
            </button>
            <!-- Header Section -->
            <div class="header-section">
                <div class="header-content">
                    <div class="header-top">
                        <div class="organization-info">
                            <h1 class="organization-name">हिंदुस्थान प्रकाशन संस्था</h1>
                            <span class="registration-number">(Reg.No.-BOM-3/1961(GBDSD))</span><br>
                            <span class="office-label">प्रशासकीय कार्यालय:</span> 116-119, शिल्पीन सेंटर, पहिला मजला,
                            40,
                            ग.द.
                            आंबेकर मार्ग,<br><span class="contact-label"> वडाळा, मुंबई - 400031, दूरध्वनी:</span>
                            7506732905
                        </div>
                        <div class="header-logo">
                            <img src="../../../assets/img/brand/book.png" alt="Logo" />
                        </div>
                    </div>
                    <hr class="header-divider" />
                    <div class="office-details-single"></div>
                </div>
            </div>

            <div class="header-title-center">
                <span> स्मरणपत्र</span>
            </div>

            <!-- Recipient Section -->
            <div class="recipient-section">
                <div class="recipient-address">
                    <div class="field-row">
                        <span class="field-label">प्रति,</span>
                    </div>
                    <div class="field-row">
                        <span class="field-value" style="font-weight: bolder;font-size: 16px ;">{{group.repName}}</span>
                    </div>
                    <div class="field-row">
                        <span class="field-value"
                            style="font-weight: bolder;font-size: 16px ;">{{group.district}}</span>
                    </div>
                </div>
                <div class="date-section">
                    <div>
                        <div class="field-row">
                            <span class="field-label">दिनांक:&nbsp;</span>
                            <span class="field-value">{{currentDate | date:'dd/MM/yyyy'}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Content Section -->
            <div class="content-section">

                <!-- Subject Line -->
                <div class="subject-line">
                    <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.subject_line" rows="2" class="form-control"
                        style="width: 100%; padding: 8px; font-weight: bold;">
                    </textarea>
                    <span *ngIf="!isEditMode">{{letterBodyText.subject_line}}</span>
                </div>

                <!-- Greeting -->
                <div class="greeting" style="text-align: left;">
                    <input *ngIf="isEditMode" type="text" [(ngModel)]="letterBodyText.greeting" class="form-control"
                        style="width: 100%; padding: 8px;">
                    <span *ngIf="!isEditMode">{{letterBodyText.greeting}}</span>
                </div>

                <!-- Letter Body -->
                <div class="letter-body">

                    <!-- Paragraph 1 -->
                    <div style="margin-bottom: 15px;">
                        <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.paragraph1" rows="4"
                            class="form-control" style="width: 100%; padding: 8px;">
                        </textarea>
                        <p *ngIf="!isEditMode">{{letterBodyText.paragraph1}}</p>
                    </div>

                    <!-- Paragraph 2 -->
                    <div style="margin-bottom: 15px;">
                        <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.paragraph2" rows="1"
                            class="form-control" style="width: 100%; padding: 8px;">
                        </textarea>
                        <p *ngIf="!isEditMode">{{letterBodyText.paragraph2}}</p>
                    </div>

                    <!-- Paragraph 3 -->
                    <div style="margin-bottom: 15px;">
                        <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.paragraph3" rows="6"
                            class="form-control" style="width: 100%; padding: 8px;">
                        </textarea>
                        <p *ngIf="!isEditMode">{{letterBodyText.paragraph3}}</p>
                    </div>

                    <!-- Details Heading -->
                    <div style="margin-bottom: 15px;">
                        <input *ngIf="isEditMode" type="text" [(ngModel)]="letterBodyText.details_heading"
                            class="form-control" style="width: 100%; padding: 8px; font-weight: bold;">
                        <p class="details-heading" *ngIf="!isEditMode">
                            {{letterBodyText.details_heading}}
                        </p>
                    </div>
                </div>

                <!-- Table Section (only this rep's invoices) -->
                <div class="table-wrapper">
                    <table class="details-table">
                        <thead>
                            <tr>
                                <th>बील क्रमांक</th>
                                <th>बील तारीख</th>
                                <th>ग्राहक नाव</th>
                                <th>Mobile No</th>
                                <th>एकूण रक्कम</th>
                                <th>येणे बाकी</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let data1 of group.data">
                                <td>{{ data1.invoice_no }}</td>
                                <td>{{ data1.invoice_date | date:'dd/MM/yyyy' }}</td>
                                <td style="text-align:left;">
                                    {{ data1.book_seller_name }}
                                </td>
                                <td style="text-align:right;">
                                    {{ data1.mobile_no }}
                                </td>
                                <td style="text-align:right;">
                                    {{ data1.invoice_total | number:'1.2-2' }}
                                </td>
                                <td style="text-align:right;">
                                    {{ data1.unpaid_amt | number:'1.2-2' }}
                                </td>
                            </tr>
                        </tbody>

                        <tfoot>
                            <tr class="total-row">
                                <td colspan="4">सर्व एकूण रक्कम</td>
                                <td style="text-align:right;">
                                    {{ group.totalAmt | number:'1.2-2' }}
                                </td>
                                <td style="text-align:right;">
                                    {{ group.totalUnpaid | number:'1.2-2' }}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <!-- Closing Text -->
                <div style="margin-top: 20px;">
                    <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.closing_text" rows="2" class="form-control"
                        style="width: 100%; padding: 8px;">
                    </textarea>
                    <p class="closing-text" *ngIf="!isEditMode">
                        {{letterBodyText.closing_text}}
                    </p>
                </div>

                <div class="row" style="margin-top: 30px; page-break-inside: avoid;">

                    <!-- LEFT: Bank Details + QR -->
                    <div class="col-7" style="padding-right: 15px;">
                        <div style="
                                border: 2px solid #000;
                                padding: 15px;
                                height: 100%;
                                display: flex;
                                justify-content: space-between;
                                align-items: flex-start;
                            ">
                            <!-- Bank Details -->
                            <div style="flex: 1;">
                                <div style="font-weight: bold; margin-bottom: 8px; font-size: 14px;">
                                    Bank Details:
                                </div>

                                <div style="line-height: 1.6; font-size: 12px;">
                                    <div><strong>A/C Name:</strong> HINDUSTAN PRAKASHAN SANSTHA</div>
                                    <div><strong>A/C No.:</strong> 20109800154</div>
                                    <div><strong>IFSC No.:</strong> MAHB0000318</div>
                                    <div><strong>Bank Name:</strong> Bank of Maharashtra</div>
                                    <div><strong>Branch:</strong> Prabhadevi, Mumbai - 400025</div>
                                </div>
                            </div>

                            <!-- QR Code -->
                            <div style="margin-left: 15px;">
                                <img src="../../../assets/img/brand/qr_code1.png" alt="QR Code"
                                    style="width: 120px; height: 120px; border: 1px solid #ddd;" />
                            </div>
                        </div>
                    </div>

                    <!-- RIGHT: SIGNATURE -->
                    <div class="col-5" style="
                            display: flex;
                            align-items: flex-end;
                            justify-content: center;
                            flex-direction: column;
                            padding-right: 20px;
                        ">
                        <p style="margin-top: 60px; font-size: 17px;margin-right: 80px;">
                            स्नेहांकित,
                        </p>

                        <p style="margin-top: 60px; font-size: 17px;margin-right: 40px;">
                            (पुस्तक विभाग प्रमुख)
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- Edit Control Buttons (edits the shared letter template used for every rep) -->
    <div class="edit-controls"
        style="margin-bottom: 15px; text-align: right; padding: 10px; background-color: #f5f5f5; border-radius: 5px;">
        <button *ngIf="!isEditMode" (click)="toggleEditMode()" class="btn btn-primary" style="margin-right: 5px;">
            <i class="fa fa-edit"></i> संपादित करा (Edit)
        </button>

        <button *ngIf="isEditMode" (click)="saveLetterTemplate()" [disabled]="isSaving" class="btn btn-success"
            style="margin-right: 5px;">
            <i class="fa fa-save"></i> {{ isSaving ? 'जतन करत आहे...' : 'जतन करा (Save)' }}
        </button>

        <button *ngIf="isEditMode" (click)="toggleEditMode()" class="btn btn-secondary" style="margin-right: 5px;">
            <i class="fa fa-times"></i> रद्द करा (Cancel)
        </button>

        <button *ngIf="isEditMode" (click)="resetToDefault()" class="btn btn-warning">
            <i class="fa fa-refresh"></i> डिफॉल्ट (Reset)
        </button>
    </div>
</div>